import createApiClient from './createGenericApiClient';

const client = createApiClient('accounts_base');

export function getAccountClient() {
	return client.getApolloClientInstance();
}

export default client.performRequest;
